import React from 'react';
import '../pages/common.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 LexGoKids</p>
    </footer>
  );
}

export default Footer;
